// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
import Swiper from 'swiper/bundle';
import { swiperOptions } from './module/SwiperFunctions';

document.addEventListener('DOMContentLoaded', () => {
  // main view
  if (document.querySelector('.mainView__swiper')) {
    new Swiper(
      '.mainView__swiper',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        speed: 3000,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
        },
        pagination: {
          el: '.mainView__swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 1.3,
          },
        },
      })
    );
  }

  // pick up
  if (document.querySelector('.pickup__swiper')) {
    new Swiper(
      '.pickup__swiper',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        speed: 1500,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
        },
        pagination: {
          el: '.pickup__swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 'auto',
          },
        },
      })
    );
  }

  if (document.getElementById('specialDecoText')) {
    const target = document.getElementById('specialDecoText');
    window.addEventListener('scroll', function () {
      const scroll = window.scrollY; //スクロール量を取得
      const windowHeight = window.innerHeight; //画面の高さを取得
      const targetPos = target.getBoundingClientRect().top + scroll; //ターゲット要素の位置を取得
      if (scroll > targetPos - windowHeight) {
        //スクロール量 > ターゲット要素の位置
        target.classList.add('is-animated');
      }
    });
  }

  // modelCourse
  if (document.querySelector('.modelCourse__swiper')) {
    new Swiper(
      '.modelCourse__swiper',
      swiperOptions({
        slidesPerView: 1.2,
        spaceBetween: 20,
        speed: 1500,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
        },
        pagination: {
          el: '.modelCourse__swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3.2,
          },
        },
      })
    );
  }

  // spotsRanking
  if (document.querySelector('.spotsRanking__swiper')) {
    new Swiper(
      '.spotsRanking__swiper',
      swiperOptions({
        slidesPerView: 1.2,
        spaceBetween: 20,
        speed: 1500,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
        },
        pagination: {
          el: '.spotsRanking__swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3.2,
          },
        },
      })
    );
  }

  // event deco text
  if (document.getElementById('eventDecoText')) {
    const targetEvent = document.getElementById('eventDecoText');
    window.addEventListener('scroll', function () {
      const scroll = window.scrollY; //スクロール量を取得
      const windowHeight = window.innerHeight; //画面の高さを取得
      const targetPos = targetEvent.getBoundingClientRect().top + scroll; //ターゲット要素の位置を取得
      if (scroll > targetPos - windowHeight) {
        //スクロール量 > ターゲット要素の位置
        targetEvent.classList.add('is-visible');
      }
    });
  }

  // important text
  if (document.getElementById('importantMessage')) {
    const messageBox = document.getElementById('importantMessage');
    const closedBtn = document.getElementById('closedBtn');
    closedBtn.addEventListener('click', () => {
      messageBox.classList.add('is-close');
    });
  }
});

// AI協調フィルタリング
const aiRecommend = document.querySelector('#top-ai-recommend');
if (aiRecommend) {
  $.ajax({
    url: '/recommends',
    data: {
      recommend_type: 'user',
      data_id: 'top-ai-recommend',
      data_type: 'top',
    },
    beforeSend(xhr) {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    },
    type: 'GET',
    timeout: 5000,
  });
}
